import * as moment from "moment";
import NotificationBase from "../NotificationBase";
import {NewThirdPartyLeadNotificationDataApiDto, NotificationBaseApiDto} from "../../../api/model/rest";
import {default as NewThirdPartyLeadNotificationData} from "./NewThirdPartyLeadNotificationData";

/**
 * New third party lead notification class.
 */
export default class NewThirdPartyLeadNotification extends NotificationBase {
	/**
	 * @param {string} id Notification id.
	 * @param {moment.Moment} visibleFrom Notification datetime.
	 * @param {boolean} read Flag if notification is marked as read.
	 * @param {"NEW_THIRD_PARTY_LEAD"} type Notification type, in this case always 'NEW_THIRD_PARTY_LEAD'.
	 * @param {NewThirdPartyLeadNotificationData} data New third party lead notification data object.
	 */
	constructor(readonly id: string,
		readonly visibleFrom: moment.Moment,
		readonly read: boolean,
		readonly type: string,
		readonly data: NewThirdPartyLeadNotificationData) {
		super(id, visibleFrom, read, type);
	}

	static fromJson(json: NotificationBaseApiDto): NewThirdPartyLeadNotification {
		return new NewThirdPartyLeadNotification(json.id, moment(json.visibleFrom), json.read, json.type,
			NewThirdPartyLeadNotificationData.fromJson(json.data as NewThirdPartyLeadNotificationDataApiDto));
	}

	copy({id = this.id, dateTime = this.visibleFrom, read = this.read, type = this.type, data = this.data}) {
		return new NewThirdPartyLeadNotification(id, dateTime, read, type, data);
	}
}